/**
 * Copyright ©2024 Drivepoint
 */

import {User} from "firebase/auth";
import WebAppServerClient from "./WebAppServerClient.ts";

export default class DrivepointUser {

  public excelUser: any;
  public companies: any[] = [];

  constructor(public user: User) {
  }

  async load(): Promise<void> {
    const data = await WebAppServerClient.request("/ui/bainbridge_user", "GET");
    this.excelUser = data.excelUser;
    this.companies = data.companies;
  }

}
